import { createFileRoute } from '@tanstack/react-router';
import { ComprasPage, lerBuscaCompras, mesAtual } from '@/components/plano';

export const Route = createFileRoute('/_app/plano/compras')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaCompras(bruto),
  component: ComprasRota,
});

function ComprasRota() {
  const busca = Route.useSearch();
  return <ComprasPage mes={busca.mes ?? mesAtual()} aba={busca.aba ?? 'compras'} />;
}
